import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {Col, Row, Tabs} from "antd";
import {SecurityScanOutlined} from "@ant-design/icons";

import LoginDetailsStaff from "../../staff/accounts/LoginDetailsStaff";
import PageTitle from "../../../components/page/PageTitle";
import {isMembershipSet} from "../../../lib/activeMember";

import {cardsGridColumn} from "../../../assets/styles";

const SecurityStaff = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (isMembershipSet() === false) {
            navigate('/member_change');
        }
    }, [navigate]);

    const tabsItems = [
        {
            label: 'Login Details',
            key: 1,
            children:
                <Row gutter={{sm: 16}}>
                    <Col {...cardsGridColumn}>
                        <LoginDetailsStaff/>
                    </Col>
                </Row>
        }
    ];

    return (
        isMembershipSet() && <>
            <PageTitle title="Security" icon={<SecurityScanOutlined/>}/>
            <Tabs defaultActiveKey="1" items={tabsItems} />
        </>
    );

}
export default SecurityStaff;

SecurityStaff.propTypes = {};
